import { load } from '@shopify/theme-sections';

import ProductImages from '../components/product-images';
import ProductForm from '../components/product-form';
import VariantLink from '../components/product-variant-link';
import Accordion from '../components/accordion';

document.addEventListener('DOMContentLoaded', () => {
  if (document.body.classList.contains('template-product')) {

    ProductImages().init();

    ProductForm({
      container: 'container',
      enableSwatches: true,
    }).init();

    VariantLink().init();

    if (document.querySelector('.accordion--product-info') !== null) {
      Accordion('.accordion--product-info', {
        singleOpen: true,
      }).init();
      Accordion('.accordion--product-info').showInitialItem();
    }

    if (document.querySelector('.accordion--product-faqs') !== null) {
      Accordion('.accordion--product-faqs', {
        singleOpen: true,
      }).init();
      Accordion('.accordion--product-faqs').showInitialItem();
    }

    load('*');

    console.log('🧐 Product: Loaded');
  }
});
